export default "__VITE_ASSET__6adcfb21__"